export default {
  "app.name": "LaundryBox",
  "app.tagline": "Your laundry. Without the wait.",
  "app.dashboard": "Laundry Dashboard",

  "lang.ar": "العربية",
  "lang.en": "English",
  "lang.switch": "Change language",

  "common.loading": "Loading…",
  "common.retry": "Retry",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.save": "Save",
  "common.confirm": "Confirm",
  "common.optional": "Optional",
  "common.currency": "SAR",
  "common.viewDetails": "View details",
  "common.backToHome": "Back to home",
  "common.required": "This field is required",
  "common.invalidEmail": "Invalid email address",
  "common.demoData": "Demo preview",
  "common.demoNote": "This is a preview with demo data.",
  "common.errorTitle": "Could not load data",
  "common.errorText": "Something went wrong while loading data. Please try again.",
  "common.empty": "Nothing to show",
  "common.requiredMark": "Required",
  "common.saving": "Saving…",
  "common.processing": "Processing…",

  "common.imageViewer.hint": "Click the image to zoom in",
  "common.imageViewer.zoomedHint": "Drag to pan, click to fit again",
  "common.imageViewer.zoomIn": "Zoom in",
  "common.imageViewer.zoomOut": "Zoom out",
  "common.imageViewer.reset": "Fit to screen",
  "upload.tooLarge": "File is larger than the allowed limit ({size} MB).",
  "upload.wrongType": "Unsupported file type.",

  "location.pick": "Pick the laundry location on the map",
  "location.hint": "Click the map to drop a precise pin for the location.",
  "location.demoBadge": "Demo picker — preview with demo data",
  "location.empty": "No location picked yet",
  "location.selectedAt": "Picked point (demo)",
  "location.notSelected": "Not selected",
  "location.clear": "Re-pick",
  "location.addressLabel": "Entered address",

  "navGroup.main": "Main",
  "navGroup.management": "Management",

  "nav.home": "Home",
  "nav.orders": "Orders",
  "nav.items": "Items & Services",
  "nav.drivers": "Sub-drivers",
  "nav.finance": "Finance & Settlements",
  "nav.reviews": "Reviews",
  "nav.notifications": "Notifications",
  "nav.settings": "Settings",

  "topbar.notifications": "Notifications",
  "topbar.account": "Account",
  "topbar.logout": "Log out",
  "topbar.menu": "Menu",
  "topbar.collapseSidebar": "Collapse sidebar",
  "topbar.expandSidebar": "Expand sidebar",

  "status.new": "Awaiting laundry approval",
  "status.accepted": "Accepted",
  "status.under_review": "Received — reviewing order",
  "status.in_progress": "In progress",
  "status.ready_for_delivery": "Ready for delivery",
  "status.completed": "Completed",
  "status.cancelled": "Cancelled",

  "priority.normal": "Normal",
  "priority.urgent": "Urgent",

  "fulfillment.self_dropoff_driver_delivery": "Branch drop-off, driver delivery",
  "fulfillment.self_dropoff_self_pickup": "Branch drop-off & pickup",
  "fulfillment.driver_pickup_self_pickup": "Driver pickup, branch pickup",
  "fulfillment.driver_pickup_driver_delivery": "On-site pickup & delivery",

  "stub.title": "This section is under construction",
  "stub.text": "This section will be implemented in the next phase of the laundry dashboard.",
  "stub.orderDetail": "Order details will be completed in the Orders Management phase.",

  "notFound.title": "Page not found",
  "notFound.text": "The requested page could not be found or is under construction.",
  "notFound.action": "Back to home"
};